import Channels from '../base/channels'
import * as Helpers from '../common/Helpers'
import axios from 'axios'
import gsap from 'gsap';



export default class FilterActions
{
  constructor(view)
  {
    this.DOM = {}
    this.DOM.view = view
    // DOM
    this.DOM.loaderView = this.DOM.view.querySelector('.jsLoader')
    this.DOM.filterView = this.DOM.view.querySelector('.FilterView')
    this.DOM.triggersFilters = this.DOM.filterView.querySelectorAll('.jsFilterTrigger')
    // this.DOM.filtersDate = this.DOM.filterView.querySelectorAll('.jsFilterDate')
    this.DOM.triggersPagination = this.DOM.view.querySelectorAll('.jsPagination')
    this.DOM.selectCategory = this.DOM.view.querySelector('.jsSelectCategory')
    // this.DOM.btnClear = this.DOM.filterView.querySelector('.jsFilterReset')
    this.DOM.filterReceptor = this.DOM.view.querySelector('.jsFilter--receptor')
    // Objects
    this.XHR = {
      'action':this.DOM.filterView.getAttribute('data-xhr'),
      'template':this.DOM.filterView.getAttribute('data-template'),
      'postID':this.DOM.filterView.getAttribute('data-postid')
    }

    this.parentPageID = this.DOM.view.getAttribute('data-parent-page')
    this.paramsFilters = {}
    this.paginationFilters = {}
    // Fns
    this.onHashChange = this.request.bind(this)
    // Flags
    this.ENABLED = true
  }

  attachToSelect()
  {
    const paramsURL = Helpers.parseHashUrl()
    let i = 0;
    for(let option of this.DOM.selectCategory.options) {
      if(option.value == paramsURL.category) {
        this.DOM.selectCategory.selectedIndex = i
        return false
      }
      i++
    }
  }

  destroy()
  {
    Channels.removeListener('window::hashchange',this.onHashChange)
  }

  events()
  {
    // for(let i = 0; i < this.DOM.triggersFilters.length; i++) {
    //   const $filter = this.DOM.triggersFilters[i]
    //   $filter.addEventListener('click',()=>{
    //     this.toggle($filter)
    //   })
    // }

    this.DOM.selectCategory.addEventListener('change',(e)=>{
      this.prepareDatas()
    })

    if(this.DOM.btnClear != null) {
      this.DOM.btnClear.addEventListener('click',()=>{
        this.resetToAll()
      })
    }


    Channels.on('window::hashchange',this.onHashChange)
  }

  eventsPagination()
  {
    this.DOM.triggersPagination = this.DOM.view.querySelectorAll('.jsPagination')

    for(let i = 0; i < this.DOM.triggersPagination.length; i++) {
      const $btn = this.DOM.triggersPagination[i]
      $btn.addEventListener('click',(e)=>{
        this.paginationFilters.number = $btn.getAttribute('data-page')
        this.request()
        e.preventDefault()
        e.stopPropagation()
      })
    }
  }

  toggleLoader(status)
  {
    if (status) {
      gsap.fromTo(
        this.DOM.loaderView,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:'cubic.out',
          duration:.7
        }
      )
    } else {
      gsap.fromTo(
        this.DOM.loaderView,
        {
          autoAlpha:1
        },
        {
          autoAlpha:0,
          ease:'cubic.out',
          duration:.7
        }
      )
    }

  }

  prepareDatas(trigger)
  {
    this.paramsFilters = []
    this.paramsFilters['category'] = []
    if(this.DOM.triggersFilters.length) {
      for(let i = 0; i < this.DOM.triggersFilters.length; i++) {
        const $filter = this.DOM.triggersFilters[i]
        const term = $filter.getAttribute('data-term')

        const value = $filter.getAttribute('data-value')
        const text = $filter.querySelector('.text').innerHTML
        if(typeof this.paramsFilters[term] == 'undefined') {
            this.paramsFilters[term] = []
        }
        if($filter.classList.contains('is--enabled')) {
            this.paramsFilters[term].push(value)
        }
      }
    }
    this.paramsFilters['category'].push(this.DOM.selectCategory.value)
    if(this.paramsFilters.category == '') {
      this.resetToAll()
    } else {
      this.sendDatasToUrl()
    }

  }

  removeSelected(btn,filter)
  {
    btn.parentElement.removeChild(btn)
    filter.classList.remove('is--enabled')
    this.fxLeaving(filter)
    this.prepareDatas()
  }

  fxLeaving(el)
  {
    el.classList.add('is--leaving')
    setTimeout(() => {
      el.classList.remove('is--leaving')
    }, 410);
  }

  sendDatasToUrl()
  {
    const query = Helpers.jsonToQueryParams(this.paramsFilters)
    window.location.hash = query
  }

  request()
  {
    if(this.ENABLED) {
      const paramsToSend = Helpers.parseHashUrl()
      if(typeof paramsToSend.reset != "undefined" && paramsToSend.reset == 1) {
        this.resetTriggers()
      } else {
        if(typeof paramsToSend.category != 'undefined') {
          if(this.DOM.btnClear != null) {
            this.DOM.btnClear.classList.remove('is--enabled')
          }
        }
      }

      this.toggleLoader(1)
      const tl = gsap.timeline()
      tl.add([
        gsap.to(
          this.DOM.filterReceptor,
          {
            autoAlpha:0,
            ease:'cubic.out',
            duration:.2,
            onComplete:()=>{
              Channels.emit('grid::repos')
            }
          }
        )
      ])
      tl.add(()=>{
      // Request
        axios.get(config.XHR_URL,{
            params : {
              'action':this.XHR.action,
              'template':this.XHR.template,
              'filters':paramsToSend,
              'postID':this.XHR.postID,
              'pagination':this.paginationFilters
            },
        })
        .then((response)=> {
          this.DOM.filterReceptor.classList.remove('is--loading')
          this.DOM.filterReceptor.innerHTML = response.data
          gsap.set(this.DOM.filterReceptor, { autoAlpha: 1 ,delay: 1 })
          Channels.emit('grid::update')
          this.toggleLoader(0)
          this.eventsPagination()
        })
      })
    }
  }

  resetTriggers()
  {
    for(let i = 0; i < this.DOM.triggersFilters.length; i++) {
      const $filter = this.DOM.triggersFilters[i]
      $filter.classList.remove('is--enabled')
      this.fxLeaving($filter)
    }
  }

  resetToAll()
  {
    if(this.DOM.btnClear != null) {
      this.DOM.btnClear.classList.add('is--enabled')
    }
    window.location.hash = 'reset=1'
  }

  setup()
  {
    this.events()
    this.eventsPagination()
    if(window.location.hash.length > 0){
        this.updateByUrl()
        this.attachToSelect()
    }
  }

  toggle(trigger)
  {
    //! Reset Pagination
    this.paginationFilters.number = 1
    //!
    this.prepareDatas()
  }

  updateByUrl()
  {
    const paramsToSend = Helpers.parseHashUrl()
    if(paramsToSend.category == '' || paramsToSend.year == '' || paramsToSend.month == '') {
      this.resetToAll()
    } else {
      this.request()
    }

  }
}
